(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/day-time-limit/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/accountservices/day-time-limit/assets/javascripts/utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

(function (svs) {
  'use strict';

  svs.accountservices = svs.accountservices || {};
  svs.accountservices.day_time_limit = svs.accountservices.day_time_limit || {};
  svs.accountservices.day_time_limit.utils = svs.accountservices.day_time_limit.utils || {};
  let timeForSoonMessage = 5,
    timeForSoonMessageText = 'fem'; 

  function setUpModel(data) {
    let req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    const dateNow = new Date(),
      dateNowMs = Date.now(),
      dayTimeLimit = {};


    if (data.dayTimeLimitIsSet) {
      const dayTimeLimitEnd = parseDateTime(data.expireTime, true, true);
      let timeToEnd = dayTimeLimitEnd - dateNowMs,
        timeToSoonEnd = timeToEnd - timeForSoonMessage * 60 * 1000; 
      const timeToSoonEndNextDay = calculateNextDayTimes(data.currentDayTimeLimit).soonEndMessageTimeNextDay,
        timeToEndNextDay = calculateNextDayTimes(data.currentDayTimeLimit).endMessageTimeNextDay;




      if (data.dayTimeExpired) {
        timeToEnd = 0;
        timeToSoonEnd = 0;
      } else {
        if (timeToSoonEnd > 0 && timeToSoonEnd < timeForSoonMessage * 60 * 1000) {
          if (timeToSoonEnd > 4 * 60 * 1000) {
            timeForSoonMessage = 4;
            timeForSoonMessageText = 'fyra';
          } else if (timeToSoonEnd > 3 * 60 * 1000) {
            timeForSoonMessage = 3;
            timeForSoonMessageText = 'tre';
          } else if (timeToSoonEnd > 2 * 60 * 1000) {
            timeForSoonMessage = 2;
            timeForSoonMessageText = 'två';
          } else if (timeToSoonEnd > 1 * 60 * 1000) {
            timeForSoonMessage = 1;
            timeForSoonMessageText = 'en';
          } else {
            timeForSoonMessage = 0;
            timeForSoonMessageText = 'mindre än en';
          }
        }
      }
      dayTimeLimit.timeToEnd = timeToEnd;
      dayTimeLimit.timeToSoonEnd = timeToSoonEnd;
      dayTimeLimit.timeToEndNextDay = timeToEndNextDay;
      dayTimeLimit.timeToSoonEndNextDay = timeToSoonEndNextDay;
      dayTimeLimit.timeForSoonMessage = timeForSoonMessage;
      dayTimeLimit.timeForSoonMessageText = timeForSoonMessageText;
      dayTimeLimit.consumedDayTimeText = convertMinutesToText(data.consumedDayTime, 'förbrukade');
      dayTimeLimit.currentDayTimeLimitText = convertMinutesToText(data.currentDayTimeLimit, 'per dag');
      dayTimeLimit.remainingDayTimeLimitText = convertMinutesToText(data.currentDayTimeLimit - data.consumedDayTime, 'kvar');
      dayTimeLimit.futureDayTimeLimitText = convertMinutesToText(data.futureDayTimeLimit, 'per dag');

      dayTimeLimit.dayTimeLimitHours = 24;
      if (typeof exports === 'object') {
        const trinidad = require('@svenskaspelab/trinidad-core').core,
          environment = trinidad.config.options.environment;
        if (environment.match(/test/) || environment.match(/itp/)) {
          if (req.route.moduleConfig.DayTimeLimitHours) {
            dayTimeLimit.dayTimeLimitHours = req.route.moduleConfig.DayTimeLimitHours;
          }
        }
      } else {
        if (svs.core.config.data.svsconfig.env !== 'production') {
          if (svs.day_time_limit.data.config.DayTimeLimitHours) {
            dayTimeLimit.dayTimeLimitHours = svs.day_time_limit.data.config.DayTimeLimitHours;
          }
        }
      }
      dayTimeLimit.nextDayTimeShiftCalculatedText = get72HoursText(dayTimeLimit.dayTimeLimitHours);
      dayTimeLimit.nextDayTimeShiftText = getNextDayTimeShiftText(false, parseDateTime(data.nextDayTimeShift, false, true));
      dayTimeLimit.hasFutureDayTimeLimit = data.futureDayTimeLimit > data.currentDayTimeLimit;
      dayTimeLimit.hasRemovedDayTimeLimit = data.futureDayTimeLimit === 0 && parseDateTime(data.nextDayTimeShift, false, true) > dateNow;

    }
    const model = _objectSpread(_objectSpread({
      id: new Date().getTime()
    }, dayTimeLimit), data);
    return model;
  }

  function calculateNextDayTimes(dayTimeLimitMinutes) {
    return {
      soonEndMessageTimeNextDay: dayTimeLimitMinutes * 60 * 1000 - timeForSoonMessage * 60 * 1000,
      endMessageTimeNextDay: dayTimeLimitMinutes * 60 * 1000
    };
  }

  function parseDateTime(inDate, withSeconds, toDate) {
    if (inDate) {
      if (toDate) {
        const year = inDate.substr(0, 4),
          month = inDate.substr(5, 2),
          day = inDate.substr(8, 2),
          hours = inDate.substr(11, 2),
          minutes = inDate.substr(14, 2),
          seconds = withSeconds ? inDate.substr(17, 2) : '0';
        return new Date(year, month - 1, day, hours, minutes, seconds);
      }
      return "".concat(inDate.substr(0, 10), " ").concat(withSeconds ? inDate.substr(11, 8) : inDate.substr(11, 5));
    }
    return undefined;
  }

  function convertMinutesToText(minutes, suffix) {
    if (minutes > 0) {
      return "".concat(Math.floor(minutes / 60), " tim och ").concat(minutes % 60, " min ").concat(suffix);
    }
    return "0 tim och 0 min ".concat(suffix);
  }

  function getNextDayTimeShiftText(addDays) {
    let inDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
    let hours = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    const zeroPad = function (n) {
      return n < 10 ? "0".concat(n) : n;
    };
    let date72h = new Date(inDate);
    if (hours < 24) {
      date72h = new Date(date72h.setHours(date72h.getHours() + (addDays ? 3 * hours : 0)));
    } else {
      date72h = new Date(date72h.setDate(date72h.getDate() + (addDays ? 3 : 0)));
    }
    return "".concat(date72h.getDate(), "/").concat(date72h.getMonth() + 1, ", kl ").concat(zeroPad(date72h.getHours()), ":").concat(zeroPad(date72h.getMinutes()));
  }

  function get72HoursText() {
    let hours = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 24;
    return "om ".concat(hours * 3, " timmar");
  }
  svs.accountservices.day_time_limit.setUpModel = setUpModel;
})(svs);
if (typeof exports === 'object') {
  module.exports = {
    setUpModel: svs.accountservices.day_time_limit.setUpModel
  };
}

 })(window);